<template>
  <div class="album-create-edit">
    <UiDataBox :loading="loading">
      <md-tabs md-fixed>
        <md-tab id="album" :md-label="isNew ? 'New album' : 'Edit album'">
          <div class="form-control">
            <input type="text" v-model="item.title" placeholder="Title">
          </div>
          <div class="form-control">
            <textarea v-model="item.description" placeholder="Description"></textarea>
          </div>
          <div class="form-control">
            <label>Event date:</label>
            <Datetime
              v-model="eventDate"
              placeholder="Choose event date">
            </Datetime>
          </div>

          <div class="form-control button">
            <md-switch
              v-model="item.private"
              :disabled="isChangeSwitchPrivateDisabled">
              {{ item.private ? 'Private' : 'Public' }}
              <span v-if="!item._cover_thumbnail">(Upload cover thumbnail to unlock switcher)</span>
            </md-switch>

            <div>
              <md-button @click="createUpdateItem" :disabled="isDisabledCreateUpdateButton">{{ createUpdateButtonTitle }}</md-button>
              <md-button v-if="!isNew" @click="removeItem">Remove album</md-button>
            </div>
          </div>
        </md-tab>


        <md-tab id="content" md-label="Content" :md-disabled="isNew">
          <div class="form-control">
            <TagsSelect
              :selectedIds="item.tags"
              @select="onTagSelect"
              @remove="onTagRemove">
            </TagsSelect>
          </div>

          <div class="image">
            <div class="current-image form-control">
              <div class="header">
                <span>Cover index</span>
                <button @click="removeCoverIndex">remove</button>
              </div>
              <img :src="item._cover_index" alt="current index cover image">
            </div>
            <div class="upload-new-image form-control">
              <UploadSingle :entityId="item.id" :entityType="'cover_index'"></UploadSingle>
            </div>
          </div>

          <div class="image">
            <div class="current-image form-control">
              <div class="header">
                <span>Cover thumbnail</span>
                <button @click="removeCoverThumbnail">remove</button>
              </div>
              <img :src="item._cover_thumbnail" alt="current index cover image">
            </div>
            <div class="upload-new-image form-control">
              <UploadSingle :entityId="item.id" :entityType="'cover_thumbnail'"></UploadSingle>
            </div>
          </div>

          <div class="form-control">
            <UploadMulti :entityId="item.id" @uploaded="fetchItem"></UploadMulti>
            <div class="photos-list">
              <div class="photo" v-for="photo in getPhotosList" :key="photo.id">
                <span class="remove-button" @click="removePhoto(photo.id)" title="remove photo">
                  <i class="material-icons">indeterminate_check_box</i>
                </span>
                <img :src="photo._thumbnail_mid" alt="">
              </div>

              <mugen-scroll :handler="loadMorePhotosHandler" :should-handle="!loading"></mugen-scroll>
            </div>
          </div>
        </md-tab>
      </md-tabs>
    </UiDataBox>

  </div>
</template>

<script>
  /**
   * альбом создается в несколько этапов
   * 1) Создается сущьность альбом
   * 1.1) Открывается след шаг
   * 2) Загружаются заглавные изображения, фото и добавдяются теги
   * 3) Публикуется альбом
   */
  import { Datetime } from 'vue-datetime'
  import MugenScroll from 'vue-mugen-scroll'

  import * as albumsService from '../../services/albums.service'
  import * as photosService from '../../services/photos.service'

  import setModelMixin from '../../mixins/setModelMixin'
  import UploadSingle from '../../components/UploadSingle.vue'
  import UploadMulti from '../../components/UploadMulti.vue'
  import TagsSelect from '../../components/TagsSelect.vue'

  export default {
    name: 'AlbumCreateEdit',
    mixins: [setModelMixin],
    components: {
      UploadSingle,
      UploadMulti,
      TagsSelect,
      Datetime,
      MugenScroll
    },

    data () {
      return {
        loading: false,
        error: false,
        photoArrayLimiter: 20,

        item: {
          id: null,
          user_id: '',
          title: '',
          description: '',
          private: true,
          event_date: '',
          created_at: '',
          _cover_thumbnail: '',
          _cover_index: '',
          tags: [],
          photos: []
        }
      }
    },

    methods: {
      log () {
        console.log(this.item)
      },
      createUpdateItem () {
        this.item.id ? this.updateItem() : this.createItem()
      },
      createItem () {
        let data = {
          user_id: this.$currentUser.id,
          title: this.item.title,
          description: this.item.description,
          private: this.item.private,
          event_date: this.item.event_date
        }

        this.loading = true
        albumsService.create(data)
          .then(response => {
            this.item = this.setModelMixin(this.item, response.data)
            this.item.tags = []
            this.$router.push({ name: 'profile-album-edit', params: { id: this.item.id } })
            this.$snotify.success('Album is created', 'All done!')
          })
          .catch(error => {
            this.$snotify.error(error.message, 'Error')
            console.log(error)
          }).finally(() => { this.loading = false })
      },
      updateItem () {
        let data = {
          user_id: this.$currentUser.id,
          title: this.item.title,
          description: this.item.description,
          private: this.item.private,
          event_date: this.item.event_date
        }

        this.loading = true
        albumsService.update(this.item.id, data)
          .then(response => {
            this.item = this.setModelMixin(this.item, response.data)
            this.$snotify.success('Album is updated', 'All done!')
          })
          .catch(error => {
            this.$snotify.error(error.message, 'Error')
            console.log(error)
          }).finally(() => { this.loading = false })
      },
      fetchItem () {
        this.loading = true
        albumsService.getById(this.$route.params.id)
          .then(response => {
            this.item = this.setModelMixin(this.item, response.data)
          }).catch(error => console.log(error))
          .finally(() => { this.loading = false })
      },
      removeItem () {
        this.$dialog.confirm(`Remove album #${this.item.id} ${this.item.title} ?`)
          .then(() => albumsService.remove(this.item.id))
          .then(response => {
            this.$snotify.success('Album is deleted', 'All done!')
            this.$router.push({name: 'profile-albums'})
          }).catch(error => {
            if (error && error.message) {
              this.$snotify.error(error.message, 'Error')
            }
            console.log(error)
          })
      },
      removeCoverIndex () {
        albumsService.removeCoverIndexImage(this.item.id)
          .then(response => {
            this.$snotify.success('Cover index deleted', 'All done!')
            this._cover_index = ''
          }).catch(error => {
            this.$snotify.error(error.message, 'Error')
            console.log(error)
          })
      },
      removeCoverThumbnail () {
        albumsService.removeCoverThumbnailImage(this.item.id)
          .then(response => {
            this.$snotify.success('Cover thumbnail deleted', 'All done!')
            this._cover_thumbnail = ''
          }).catch(error => {
            this.$snotify.error(error.message, 'Error')
            console.log(error)
          })
      },
      onTagSelect (selectedTag) {
        albumsService.attachTag(this.item.id, selectedTag.id)
          .then(response => {
            this.item.tags.push(selectedTag)
            this.$snotify.success('Attached', `Tag: ${selectedTag.label}`)
          }).catch(error => {
            this.$snotify.error(error.message, 'Error')
            console.log(error)
          })
      },
      onTagRemove (selectedTag) {
        albumsService.detachTag(this.item.id, selectedTag.id)
          .then(response => {
            this.item.tags = this.item.tags.filter(item => item.id !== selectedTag.id)
            this.$snotify.success('Detached', `Tag: ${selectedTag.label}`)
          }).catch(error => {
            this.$snotify.error(error.message, 'Error')
            console.log(error)
          })
      },
      removePhoto (photoId) {
        this.$dialog.confirm(`Remove photo #${photoId} ?`)
          .then(() => photosService.remove(photoId))
          .then(() => {
            this.$snotify.success('Removed', `Photo: ${photoId}`)
            this.item.photos = this.item.photos.filter(item => item.id !== photoId)
          }).catch(error => {
            if (error && error.message) {
              this.$snotify.error(error.message, 'Error')
            }
            console.log(error)
          })
      },
      loadMorePhotosHandler () {
        if (this.photoArrayLimiter > this.item.photos.length) return
        this.photoArrayLimiter += 8
      }
    },

    computed: {
      isNew () {
        return !this.item.id
      },
      createUpdateButtonTitle () {
        return this.item.id ? 'Update' : 'Create'
      },
      isChangeSwitchPrivateDisabled () {
        return this.isNew || !this.item._cover_thumbnail
      },
      eventDate: {
        get () {
          return this.item.event_date ? this.item.event_date : ''
        },
        set (date) {
          if (this.item.event_date) {
            this.item.event_date = date
          } else {
            this.$set(this.item, 'event_date', date)
          }
        }
      },
      isDisabledCreateUpdateButton () {
        return this.loading || !this.item.title || !this.item.event_date
      },
      getPhotosList () {
        if (!this.item.photos) return
        return this.item.photos.slice(0, this.photoArrayLimiter)
      }
    },

    mounted () {
      if (this.$route.params.id) {
        this.fetchItem()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .album-create-edit {
    width: 100%;

    #album {
      min-height: 500px;
    }

    .md-tabs .md-tab {
      padding: 15px 0 !important;
    }

    .form-control.button {
      display: flex;
      justify-content: space-between;
    }

    .image{
      display: flex;
      margin: 10px 0;
      .header {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
        padding: 2px 10px;
        background-color: $color-page;
      }
      .upload-new-image, .current-image {
        width: calc(50% - 5px);
        margin: 0 5px;
      }
    }

    .photos-list{
      display: flex;
      flex-wrap: wrap;
      /*justify-content: space-around;*/
      .photo {
        background-color: $color-page;
        padding: 15px;
        width: 30%;
        margin: 5px auto;
        position: relative;
        &:hover .remove-button {
          display: inline;
        }
        .remove-button {
          display: none;
          position: absolute;
          top: 20px;
          left: 20px;
          padding: 2px;
          cursor: pointer;
          font-size: 20px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/profile/AlbumCreateEdit.vue